import { classNameType } from "@/types/generalTypes";
import React from "react";

function ArrowDropdown({ className }: classNameType) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="4"
      viewBox="0 0 8 4"
      fill="none"
    >
      <path
        d="M1.20497 0.125H6.79097C6.88985 0.125019 6.9865 0.15191 7.0687 0.202274C7.15091 0.252638 7.21498 0.324212 7.25281 0.40795C7.29065 0.491687 7.30055 0.583827 7.28126 0.672722C7.26198 0.761617 7.21438 0.843275 7.14447 0.907374L4.35147 3.46762C4.25771 3.55354 4.13055 3.60181 3.99797 3.60181C3.86539 3.60181 3.73824 3.55354 3.64447 3.46762L0.851472 0.907374C0.781567 0.843275 0.733964 0.761617 0.71468 0.672722C0.695396 0.583827 0.705298 0.491687 0.743133 0.40795C0.780968 0.324212 0.845037 0.252638 0.927242 0.202274C1.00945 0.15191 1.1061 0.125019 1.20497 0.125Z"
        fill="#374957"
      />
    </svg>
  );
}

export default ArrowDropdown;
